import * as React from 'react';
import * as styles from './MixedEntityItem.scss';
import ImageEnhanced from '../../../../components/General/ImageEnhanced/ImageEnhanced';
import Link from '../../../Base/components/Link/Link';
import { IMixedEntityType } from '../../types/IMixedEntityType';

interface IMixedEntityBrandItemProps {
	data: IMixedEntityType;
	columns?: '1' | '2' | '3' | '4' | '5';
}

class MixedEntityBrandItem extends React.Component<IMixedEntityBrandItemProps, {}> {
	public render () {
		const { data, columns } = this.props;

		return (
			<Link
				route="BrandDetailRoute"
				params={{
					brand: data.slug
				}}
			>
				<span
					className={`${styles.MixedEntityItemWrapper} ${styles['MixedEntityItemWrapperColumns' + columns]}`}
				>
					<span
						className={styles.MixedEntityItemWrapperInner}
					>
						<span className={`${styles.ImageWrapper} ${styles.BrandImageWrapper}`}>
							<ImageEnhanced
								 source={data.image}
							/>
						</span>

						<span className={styles.Content}>
							<span className={styles.Heading}>
								{data.title}
								{/* // if title is too long -> show fade out */}
								{ (data.title?.length < 55) ? null :
									<span className={styles.HeadingFadeout} />
								}
							</span>
						</span>
					</span>
				</span>
			</Link>
		);
	}

}


export default MixedEntityBrandItem;


